import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InfoTileComponent} from '../../info-tile/info-tile.component';
import {PlacementService} from '@/services/placement.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-mortality-stats',
    standalone: true,
    imports: [CommonModule, InfoTileComponent],
    templateUrl: './mortality-stats.component.html',
    styleUrl: './mortality-stats.component.scss'
})
export class MortalityStatsComponent implements OnChanges {
    @Input() placementId: number | null = null;

    mortalityStats: any = {
        totalMortalities: 0,
        mortalityRate: 0,
        mortalityPerDay: 0,
        records: 0
    };

    constructor(
        private placementService: PlacementService,
        private toastr: ToastrService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['placementId'] && this.placementId) {
            this.getTotalMortalities(this.placementId);
        }
    }

    getTotalMortalities(placementId: number): void {
        this.placementService.getTotalMortalities(placementId).subscribe({
            next: (response) => {
                this.mortalityStats = response;
            },
            error: (error) => {
                this.toastr.error('Failed to load mortality summary.');
            }
        });
    }
}
